import CreateVehicleForm from "./CreateVehicleForm";

export default CreateVehicleForm;